import { loadMessages, locale } from "devextreme/localization";
import {
  call,
  createPersistor,
  createStore,
  parallel,
  PERSIST_LOADER_ID,
  persistStoreMdw,
  select,
  spawn,
  take,
} from "starfx";

import { setupDevTool, subscribeToActions } from "@app/contexts/devtools";
import roMessages from "@app/locales/devex.ro.json";
import {
  CONST_XAPI_INSIDER_LOGOUT_NAME,
  PERSISTOR_NAME,
} from "@app/state/constants";
import { initialState, schema } from "@app/statefx/schema";

// import { connectReduxDevToolsExtension } from '../context/jbDevtools';
import { createIDBStorageAdapter } from "../stateCommon/idbAdapters";
import { selectorWorkerGxDBName } from "./selectors/app.sel";
import { initGxWorker } from "./workers";
import { xApi, xDbc, xouterApi, xThunk, xWorker } from "./xapis";
import { getAppEnv } from "./xThunks/app";
import { runBootSequence } from "./xThunks/ds";
import {
  invoiceActionsFromDelphi,
  receiveSpvMessageFromDelphi,
  receiveStdoutFromDelphi,
  resetIndexedDB,
} from "./xThunks/saga-stdout";

import type { Operation } from "starfx";
export type AppState = typeof initialState;

function* loclalizationRo() {
  yield* call(() => loadMessages(roMessages));
  yield* call(() => locale("ro"));
}
let appIsPersonalKarma;
const devtoolsEnabled = false;
// process.env.NODE_ENV === "development";

//  process.env.REACT_APP_MODE === 'REACT';

// const pName = "app.default";

// // we deliberately use a different database for the worker thread.
// // this is an arhitectural decision to avoid the main thread to be blocked by the worker thread.
// // w. worker
// pName && initGxWorker(`w.${pName}`);
// pName && initHxWorker(`w.${pName}`);

// function* initWorker(): Operation<void> {
//   while (true) {
//     yield* take("*");
//     const who = yield* select(schema.whoami.select);
//     if (who.AmaId && who.wai_database) {
//       break;
//     }
//   }
//   const indexDbName = yield* select(selectorWorkerGxDBName);
//   initGxWorker(indexDbName);
// }

const tasks = [
  // connectReduxDevToolsExtension({
  //   name: pName,
  //   store,
  //   enabled: devtoolsEnabled
  // }),
  function* devtools() {
    if (!devtoolsEnabled) return;
    while (true) {
      const action = yield* take("*");
      subscribeToActions(null, { action });
    }
  },
  function* () {
    yield* call(() => getAppEnv());
  },
  function* () {
    yield* call(() => receiveStdoutFromDelphi());
  },
  function* () {
    yield* call(() => receiveSpvMessageFromDelphi());
  },
  function* () {
    yield* call(() => invoiceActionsFromDelphi());
  },
  function* () {
    yield* call(() => resetIndexedDB());
  },
  function* () {
    yield* call(() => loclalizationRo());
  },
  function* () {
    // yield* call(runBootSequence.run());
  },
];
export const allowlist = [
  "app",
  "contactlist",
  "contractors_anaf",
  "contractors_cff",
  "contractors_temp",
  "currencies",
  "currencyRates",
  "fileSysContent",
  "fileSysHead",
  "fileSysLocalDisk",
  "fiscalBooks",
  "fsDirTree",
  "invoiceCollection",
  "invoiceFiscal",
  "invoiceIssuer",
  "iso3166_2",
  "isoNewCities",
  "issuerBankAccounts",
  "ivtrackgrid",
  "listModels",
  "persistorGuardian",
  "SPVInvoiceRaw",
  "SPVMessageKeys",
  "SPVMessages",
  "SPVMessageUserState",
  "uiAllotment",
  "uiAllotmentCollapsed",
  "uiCollectionCurrent",
  "uiContractorsEditing",
  "uiFiscalBooks",
  "uiInvoiceCurrent",
  "uiInvoiceEditing",
  "uiInvoiceOverall",
  "uiJGBrowserHeader",
  "uiPersistInvoiceGrid",
  "uiPersistSpvList",
  "uiSpvGrid",
  "uiSpvMain",
] as (keyof AppState)[];
export const persistor = createPersistor<AppState>({
  //m. main
  adapter: createIDBStorageAdapter<AppState>(PERSISTOR_NAME),
  allowlist: allowlist,
});

export const store = createStore({
  initialState: initialState,
  middleware: [persistStoreMdw(persistor)],
});
window["fx"] = store; //important //

export const runFxState = () => {
  devtoolsEnabled && setupDevTool({}, { name: "starfx", enabled: true });
  store.run(function* () {
    yield* persistor.rehydrate();
    yield* schema.update(schema.loaders.success({ id: PERSIST_LOADER_ID }));
    // yield* spawn(() => initWorker());
    const group = yield* parallel([
      ...tasks,
      xApi.bootup,
      xThunk.bootup,
      xWorker.bootup,
      xouterApi.bootup,
      xDbc.bootup,
    ]);

    yield* group;
  });
  return store;
};

export const fxDispatch = store.dispatch;
